import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatButtonModule, MatCheckboxModule, MatDialogModule, MatFormFieldModule } from '@angular/material';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatCardModule } from '@angular/material/card';
import { AboutUsComponent } from './about-us/about-us.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatInputModule } from '@angular/material/input';
import { SignupComponent } from './signup/signup.component';
import { LoginComponent } from './login/login.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SiteHeaderComponent } from './layout/site-header/site-header.component';
import { SiteLayoutComponent } from './layout/site-layout/site-layout.component';
import { SiteFooterComponent } from './layout/site-footer/site-footer.component';
import { HomeComponent } from './home/home.component';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatRadioModule } from '@angular/material/radio';
import { MatSliderModule } from '@angular/material/slider';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NgxLoadingModule, ngxLoadingAnimationTypes } from 'ngx-loading';
import { ProductDescriptionComponent } from './product-description/product-description.component';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { MatSelectModule } from '@angular/material/select';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import {NgPipesModule} from 'ngx-pipes';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';


import { SignUpService } from './_services/sign-up.service';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { CategoryComponent } from './category/category.component';
import { ShowHidePasswordModule } from 'ngx-show-hide-password';
import { AuthInterceptorService } from './_services/auth-interceptor.service';

import { CookieService } from 'ngx-cookie-service';
import { FeedbackPageComponent } from './feedback-page/feedback-page.component';
import { SnotifyModule, ToastDefaults, SnotifyService } from 'ng-snotify';
import { MatChipsModule } from '@angular/material/chips';


import { AppHeaderComponent } from './layout/app-header/app-header.component';
import { AppLayoutComponent } from './layout/app-layout/app-layout.component';
// import {ROUTER_PROVIDERS} from '@angular/router'
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { SWIPER_CONFIG } from 'ngx-swiper-wrapper';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { ProductSearchComponent } from './product-search/product-search.component';
import { MatTreeModule } from '@angular/material/tree';
import { CarouselModule } from 'ngx-owl-carousel-o';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { SliderModule } from 'angular-image-slider';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { CustomDesignComponent } from './custom-design/custom-design.component';
import {MatPaginatorModule} from '@angular/material/paginator';
import { ProductImageComponent } from './product-image/product-image.component';
import { TermsConditionComponent } from './terms-condition/terms-condition.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';



@NgModule({
  declarations: [
    AppComponent,
    AboutUsComponent,
    SignupComponent,
    LoginComponent,
    SiteHeaderComponent,
    SiteLayoutComponent,
    SiteFooterComponent,
    HomeComponent,
    ProductDescriptionComponent,
    ContactUsComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    FeedbackPageComponent,
    CategoryComponent,
    AppHeaderComponent,
    AppLayoutComponent,
    ProductSearchComponent,
    ConfirmDialogComponent,
    CustomDesignComponent,
    ProductImageComponent,
    TermsConditionComponent,
    PrivacyPolicyComponent,
    
  ],
  imports: [
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatMenuModule,
    MatToolbarModule,
    MatCardModule,
    MatSidenavModule,
    MatInputModule,
    MatFormFieldModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatGridListModule,
    MatExpansionModule,
    MatRadioModule,
    MatSliderModule,
    FlexLayoutModule,
    MatListModule,
    MatIconModule,
    MatTabsModule,
    MatTableModule,
    MatSelectModule,
    FormsModule, 
    ReactiveFormsModule,
    ShowHidePasswordModule,
    SnotifyModule,
    MatTreeModule,
    BrowserAnimationsModule,
    MatTreeModule,
    MatChipsModule,
    CarouselModule,
    SliderModule,
    AngularFontAwesomeModule,
    FontAwesomeModule,
    NgbModule,
    MatPaginatorModule,
    MatDialogModule,
    NgPipesModule,
    NgxLoadingModule.forRoot({
      animationType: ngxLoadingAnimationTypes.wanderingCubes,
      backdropBackgroundColour: 'rgba(0,0,0,0.1)',
      backdropBorderRadius: '10px',
      fullScreenBackdrop: true,
      primaryColour: '#a4a4a4',
      secondaryColour: '#c234f17d',
      tertiaryColour: '#ffffff'
    })
    
  ],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: 'SnotifyToastConfig', useValue: ToastDefaults },
    CookieService,
    SignUpService,
    // {
    //   provide: SWIPER_CONFIG,
    //   useValue: DEFAULT_SWIPER_CONFIG
    // },
    SnotifyService,

  ],
  bootstrap: [AppComponent,]
})

export class AppModule { }
